import React, { useState } from 'react';
import { TextInput, Text, Stack, ActionIcon, Group } from '@mantine/core';
import { IconPlus, IconX } from '@tabler/icons-react';

type Props = {
    label: string;
    description: string;
    value: string[];
    onChange: (items: string[]) => void;
};

export function ReasonListEditor({
    label,
    description,
    value,
    onChange,
}: Props) {
    const [newReason, setNewReason] = useState('');

    const addReason = () => {
        const trimmed = newReason.trim();
        if (!trimmed || value.includes(trimmed)) return;
        onChange([...value, trimmed]);
        setNewReason('');
    };

    const removeReason = (index: number) => {
        onChange(value.filter((_, i) => i !== index));
    };

    return (
        <div>
            <Text fw={500} size="sm" mb={2}>
                {label}
            </Text>
            <Text size="xs" c="dimmed" mb="xs">
                {description}
            </Text>
            <Stack gap={4}>
                {value.map((reason, index) => (
                    <Group
                        key={reason}
                        gap="xs"
                        wrap="nowrap"
                        className="rounded border border-gray-200 bg-gray-50 pl-3 pr-1 py-1"
                    >
                        <Text size="sm" className="flex-1 truncate">
                            {reason}
                        </Text>
                        <ActionIcon
                            variant="subtle"
                            color="red"
                            size="sm"
                            onClick={() => removeReason(index)}
                        >
                            <IconX size={14} />
                        </ActionIcon>
                    </Group>
                ))}
            </Stack>
            <Group gap="xs" mt="xs">
                <TextInput
                    placeholder="Type a new reason..."
                    size="sm"
                    className="flex-1"
                    value={newReason}
                    onChange={e => setNewReason(e.currentTarget.value)}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            addReason();
                        }
                    }}
                />
                <ActionIcon
                    variant="filled"
                    size="lg"
                    onClick={addReason}
                    disabled={!newReason.trim()}
                >
                    <IconPlus size={16} />
                </ActionIcon>
            </Group>
        </div>
    );
}
